module.exports = __webpack_public_path__ + "img/welcome.a4ca442f.png";